import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import {MoreVert} from '@material-ui/icons';
import SimpleMenu from '../../shared/menu/SimpleMenu.js';

// A partir de quantas ações as excedentes vão para o menu (padrão: 2 ícones + menu).
const LIMITE_ICONES = 4;
const ICONES_COM_MENU = 2;

const useStyles = makeStyles(() => ({
    // Ícones na mesma linha, sem quebrar.
    acoes: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    }
}));

/*
 * Ações de uma linha da tabela no padrão UNAERP (como no unaserv e na lista de
 * Inscrições): IconButton no tamanho e cor padrão, com aria-label e title;
 * com 4 ou mais ações, as 2 primeiras ficam como ícone e as demais no menu de
 * três pontinhos, com as cores do padrão (front-05 §4.1.7).
 */
export function OpcoesLinha({acoes = []}) {
    const classes = useStyles();
    const theme = useTheme();

    if (!acoes.length) {
        return null;
    }

    const comMenu = acoes.length >= LIMITE_ICONES;
    const icones = comMenu ? acoes.slice(0, ICONES_COM_MENU) : acoes;
    const noMenu = comMenu ? acoes.slice(ICONES_COM_MENU) : [];

    return (
        <div className={classes.acoes}>
            {icones.map(acao => (
                <IconButton
                    key={acao.titulo}
                    aria-label={acao.titulo}
                    title={acao.titulo}
                    disabled={acao.desabilitado}
                    onClick={acao.onClick}>
                    {acao.icone}
                </IconButton>
            ))}
            {noMenu.length > 0 && (
                <SimpleMenu
                    icon={MoreVert}
                    iconButton
                    iconButtonColor={theme.palette.secondary.dark}
                    menuColor={theme.palette.tertiary.main}
                    fontColor='white'
                    label='Mais opções'
                    options={noMenu.map(acao => ({
                        label: acao.titulo,
                        icon: acao.icone ? acao.icone.type : undefined,
                        onClick: acao.onClick,
                        disabled: acao.desabilitado
                    }))}/>
            )}
        </div>
    );
}

OpcoesLinha.propTypes = {
    acoes: PropTypes.arrayOf(PropTypes.shape({
        titulo: PropTypes.string.isRequired,
        icone: PropTypes.node,
        onClick: PropTypes.func,
        desabilitado: PropTypes.bool,
        visivel: PropTypes.bool
    }))
};

/*
 * Coluna "Opções" do DataGrid (sempre a última). `obterAcoes(linha)` devolve
 * [{titulo, icone, onClick, desabilitado?, visivel?}]; as com `visivel: false`
 * ficam de fora. Use com `className: classes.buttonTableCell`.
 */
export const criarColunaOpcoes = (obterAcoes, {className, label = 'Opções'} = {}) => ({
    label,
    filterable: false,
    sortable: false,
    className,
    valueGetter: (valor, row) => (
        <OpcoesLinha acoes={(obterAcoes(row) || []).filter(acao => acao && acao.visivel !== false)}/>
    )
});
